import { render, staticRenderFns } from "./SimpleCounter.vue?vue&type=template&id=12201e67"
import script from "./SimpleCounter.vue?vue&type=script&lang=js"
export * from "./SimpleCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports